import { PropsWithChildren } from 'react';

import { css, keyframes } from '@compiled/react';

const slideUpKeyframes = keyframes({
	from: {
		transform: 'translateY(3rem)',
	},
	to: {
		transform: 'translateY(0)',
	},
});
const slideDownKeyframes = keyframes({
	from: {
		transform: 'translateY(0rem)',
	},
	to: {
		transform: 'translateY(3rem)',
	},
});

const slideRightKeyframes = keyframes({
	from: {
		transform: 'translateX(13rem)',
	},
	to: {
		transform: 'translateX(0)',
	},
});

const slideLeftKeyframes = keyframes({
	from: {
		transform: 'translateX(-13rem)',
	},
	to: {
		transform: 'translateX(0)',
	},
});

export function indexOf<T>(collection: Array<T>, predicate: (item: T | undefined) => boolean) {
	for (let i = 0; i < collection.length; i++) {
		const item = collection[i];
		if (predicate(item)) {
			return i;
		}
	}

	return -1;
}

export type MotionContainerProps = {
	direction: 'up' | 'left' | 'right' | 'down' | 'none';
};

export const MotionContainer = ({
	direction = 'up',
	children,
}: PropsWithChildren<MotionContainerProps>) => {
	return (
		<div
			css={[
				direction === 'left' && css({ animationName: slideLeftKeyframes }),
				direction === 'right' && css({ animationName: slideRightKeyframes }),
				direction === 'up' &&
					css({
						animationName: slideUpKeyframes,
					}),
				direction === 'down' &&
					css({
						animationName: slideDownKeyframes,
					}),
				css({
					animationDuration: '250ms',
				}),
			]}
		>
			{children}
		</div>
	);
};
